export const SPRING_CONFIG = {
  damping: 60,
  stiffness: 100,
} as const

export const TRANSITION_DURATION = 0.7 // seconds, matching our duration-700 class
